<template>
    <!-- 单选题 -->
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
            <div v-else style="margin-top: 8px">{{ dataList.questionNumber }}</div>
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor ref="titileInput" class="titile-input" v-model:valueData="dataList.title" />
            </div>
            <ul class="content">
                <draggable
                    :group="{
                        name: 'name1',
                        put: false,
                        pull: false,
                    }"
                    force-fallback="true"
                    v-model="dataList.optionsList"
                    animation="300"
                    itemKey="id"
                    handle=".operation-drag"
                    ghostClass="option-ghost-class"
                >
                    <template #item="{ element, index }">
                        <li class="content-item">
                            <div class="placeholder-content">
                                <!-- 输入框 -->
                                <div class="operation-drag">
                                    <!-- <img src="@/images/icon/operation_drag2@3x.png" /> -->
                                    <svg-icon name="operationSort" class="svg-icon" />
                                </div>
                                <rich-text-editor
                                    :class="element.other ? 'content-input content-input-other' : 'content-input'"
                                    v-model:valueData="element.value"
                                    @mouseenter="() => (element.buttonShowHover = true)"
                                    @mouseleave="() => (element.buttonShowHover = false)"
                                    @focus="() => (element.buttonShow = true)"
                                    @blur="() => (element.buttonShow = false)"
                                >
                                    <template #operation>
                                        <!-- 鼠标触摸展示的按钮 -->
                                        <div class="operation-box" v-show="element.buttonShow || element.buttonShowHover">
                                            <div class="operation-delete" v-if="dataList.optionsList.length > 1" @click="deleteOption(index)">
                                                <el-tooltip content="删除" effect="customized" placement="top">
                                                    <svg-icon name="operationDelete" class="svg-icon" />
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </template>
                                </rich-text-editor>
                            </div>
                        </li>
                    </template>
                </draggable>
            </ul>
            <!-- 底部操作栏 -->
            <div class="footer-operation">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                >
                    <!-- 添加左侧操作按钮 -->
                    <template #operation>
                        <div class="bottom-operation">
                            <div class="button1" @click="addSingleOption(false)"><svg-icon name="addOption" class="icon" />添加选项</div>
                            <div class="button1" @click="addSingleOption(true)"><svg-icon name="addOption" class="icon" />添加其他项</div>
                            <div class="button1" @click="openBatchDialog"><svg-icon name="batchEdit" class="icon" />批量编辑选项</div>
                        </div>
                    </template>
                </action-bar>
            </div>
            <batch-edit ref="batchEdit" :optionsList="dataList.optionsList" @confirmOption="confirmOption" />
        </div>
    </div>
</template>
<script setup name="kr-sort">
// js
import Draggable from "vuedraggable";
import { ref, watch, provide } from "vue";
// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import BatchEdit from "@/components/dialog/BatchEdit.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
// 复制题目，删除题目, 数据改变, 单题预览;
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]);
const batchEdit = ref(null);
const titileInput = ref(null);
watch(
    () => props.dataList,
    (curr, old) => {
        emits("change", curr);
    },
    { deep: true }
);

provide("data", props.dataList);
defineExpose({ titileInput });

// 打开批量编辑选项弹框
function openBatchDialog() {
    batchEdit.value.dialogVisible = true;
    batchEdit.value.newOption = "";
}

function confirmOption(data) {
    props.dataList.optionsList = data;
}

// 删除当前选项
function deleteOption(index) {
    props.dataList.optionsList.splice(index, 1);
}

// 添加单个选项
function addSingleOption(other) {
    // other 是其他选项 true和undefined
    let defaultHolder = other ? "其他" : `选项${props.dataList.optionsList.length + 1}`;
    let obj = {
        value: defaultHolder,
        id: `1-${props.dataList.optionsList.length + 1}`,
        other,
    };
    props.dataList.optionsList.push(obj);
}
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;
.content {
    width: calc(100% - 206px);
}
.content-item {
    position: relative;
    // background-color: #fff;
    position: relative;
    margin-bottom: 6px;
    padding-left: 23px;
    cursor: pointer;
    .content-input {
        color: rgba(112, 120, 134, 1) !important;
    }
    .content-input-other {
        :deep(.editor-content::after) {
            position: relative;
            top: 4px;
            content: "";
            display: inline-block;
            width: 92px;
            height: 19px;
            border: 1px solid rgba(235, 237, 243, 1);
            border-radius: 4px;
            background-color: #fff;
            margin-left: 10px;
        }
    }
    .operation-box {
        display: flex;
        align-items: center;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(100%, -50%);
        color: #9aa1ad;
    }
    .operation-delete {
        width: 18px;
        height: 18px;
        margin-left: 10px;
        .svg-icon {
            width: 100%;
            height: 100%;
            &:hover {
                color: red;
            }
        }
    }
    .operation-drag {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 18px;
        height: 18px;
        color: #9aa1ad;
        .svg-icon {
            width: 100%;
            height: 100%;
            &:hover {
                color: #2672ff;
            }
        }
    }
}
</style>
